import { LayoutDashboard, School, Users, Building2 } from "lucide-react";

/**
 * Single source of truth for dashboard navigation.
 * Both Sidebar.jsx and the mobile bottom nav in dashboard-layout.jsx
 * import from here - they can never diverge.
 *
 * short: abbreviated label for the mobile nav where space is tight.
 */
export const NAV_ITEMS = [
  { name: "Dashboard",      short: "Home",    path: "/dashboard",     icon: LayoutDashboard },
  { name: "My School",     short: "Schools", path: "/schools",       icon: Building2 },
  { name: "My Classes",     short: "Classes", path: "/classes",       icon: School },
  { name: "Shared Classes", short: "Shared",  path: "/shared-classes", icon: Users },
];
